import * as React from "react";
import { IAppointmentScheduleResponse } from "@curefit/care-common";
import AppUtils from "../utils/AppUtils";
import { AppConstants, ConsultationStatusConstant } from "../utils/AppConstants";
import { RouteUtils } from "../routes";
import * as moment from "moment";

const DashboardMobileDayPanel: React.SFC<any> = (props) => {

  const getCellBackgroundClasses = (appointment: IAppointmentScheduleResponse) => {
    let cellBackgroundClasses = "";
    // completed [.upcoming-appointment, .completed-appointment]
    cellBackgroundClasses += appointment.endTime < props.currentTime ? "completed-appointment" : "upcoming-appointment";

    // online or not
    cellBackgroundClasses += (appointment.consultationProduct.consultationMode === AppConstants.ConsultationModes.ONLINE.id) ? " video-appointment" : ""


    // missed
    cellBackgroundClasses += (appointment.status === ConsultationStatusConstant.MISSED) ? " missed-appointment" : "";

    // status class
    cellBackgroundClasses += ` ${appointment.status.toLowerCase()}`;

    return cellBackgroundClasses;
  }

  const getShowCurrentTimeMarker = (currAppointment: IAppointmentScheduleResponse, prevAppointment?: IAppointmentScheduleResponse) => {

    // no appointments, no line
    if (props.dayInfo.appointments.length === 0) {
      return false;
    }

    // if appointment not today, return no line
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();
    const appointmentMonth = new Date(currAppointment.startTime).getMonth();
    const appointmentDay = new Date(currAppointment.startTime).getDate();

    if (currentMonth !== appointmentMonth || appointmentDay !== currentDay) {
      return false;
    }

    // check where the line should be between different appointments
    const now = new Date().getTime();
    if (!prevAppointment) {
      if (now < currAppointment.endTime) {
        return true
      } else {
        return false
      }
    }
    const prevEndTime = prevAppointment.endTime;
    const currEndTime = currAppointment.endTime;
    if (now > prevEndTime && now < currEndTime) {
      return true
    }
    return false;
  }

  const isToday = moment(new Date(props.currentTime)).format("DD MM YYYY") === moment(new Date(props.dayInfo.dayEpochInfo.startEpoch)).format("DD MM YYYY");
  return (
    <section className="calendar-mobile">
      {props.dayInfo.dayEpochInfo.dateText === "1" && (
        <div className="calendar-month-marker">
          {moment(new Date(props.dayInfo.dayEpochInfo.startEpoch)).format("MMMM YYYY")}
        </div>
      )}
      <div className="slot-cells-container">
        <div className="day-container">
          <div className="day-title">{props.dayInfo.dayEpochInfo.dayOfWeek.slice(0, 3)}</div>
          <div className={`day-number ${isToday && "day-number-active"}`}>{props.dayInfo.dayEpochInfo.dateText}</div>
        </div>
        <div className="calendar-appointments-container">
          {props.dayInfo.appointments.map((appointment: IAppointmentScheduleResponse, index: number) => {
            const audioVideoIcon = props.getAudioVideoIcon(appointment);
            const appointmentUrl = AppUtils.getConsultationUrl(appointment.patient.id, appointment.id);
            const currentTimeMarker = getShowCurrentTimeMarker(appointment, index === 0 ? null : props.dayInfo.appointments[index - 1]);
            return (
              <React.Fragment key={appointment.bookingId}>
                {currentTimeMarker && (
                  <div className="now-marker" />
                )}
                <a className="mobile-consultation-nav-link" href={appointmentUrl} onClick={(e) => { RouteUtils.navigateToHrefUrl(e, appointmentUrl); return false }}>
                  <div className={`slot-cell ${getCellBackgroundClasses(appointment)}`}>
                    <div className="calendar-mobile-top-row">
                      {audioVideoIcon && (
                        <img src={audioVideoIcon} className="appointment-icon-text" />
                      )}
                      <div className="slot-general-text">
                        <span>{AppUtils.getHourMinuteFormattedDate(appointment.startTime)}</span>
                        <span> - </span>
                        <span>{AppUtils.getHourMinuteFormattedDate(appointment.endTime)}</span>
                      </div>
                    </div>
                    <div className="patient-name">{appointment.patient.name}</div>
                    <div className={`slot-general-text ${(appointment as any).delayedInMinutes ? "highlight" : ""}`}>
                      {(appointment as any).delayedInMinutes && `Delayed by ${(appointment as any).delayedInMinutes} minutes`}
                      {!(appointment as any).delayedInMinutes && appointment.consultationProduct && appointment.consultationProduct.name}
                    </div>
                  </div>
                </a>
              </React.Fragment>
            );
          })}
          {props.dayInfo.appointments.length === 0 && (
            <div className="no-appointments">No appointments scheduled</div>
          )}
        </div>
      </div>
    </section>
  );
}

export default DashboardMobileDayPanel;
